module.exports = __webpack_public_path__ + "img/technology-21.1fb6a053.png";